import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiArrowLeft, FiShield, FiTruck, FiHeadphones, FiStar, FiZap, FiPhone, FiChevronLeft, FiChevronRight, FiCheckCircle, FiAward, FiPackage } from 'react-icons/fi';
import api from '../utils/api';
import OldFanOfferPopup from '../components/OldFanOfferPopup';
import './pages.css';

const categories = [
  { id: 'LED_LIGHTS', name: 'LED Lights', nameML: 'LED ലൈറ്റുകൾ', img: '/categories/led-lights.jpg', icon: '/icons/led-lights.svg', fallback: 'https://images.unsplash.com/photo-1565814329452-e1432341ceab?w=600&h=400&fit=crop&q=80', desc: 'Bulbs, panels, battens', overlay: 'rgba(245,158,11,0.85)' },
  { id: 'SWITCHES', name: 'Switches', nameML: 'സ്വിച്ചുകൾ', img: '/categories/switches.jpg', icon: '/icons/switches.svg', fallback: 'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=600&h=400&fit=crop&q=80', desc: 'Modular & classic', overlay: 'rgba(59,130,246,0.85)' },
  { id: 'WIRES_CABLES', name: 'Wires & Cables', nameML: 'വയറുകൾ', img: '/categories/wires-cables.jpg', icon: '/icons/wires-cables.svg', fallback: 'https://images.unsplash.com/photo-1510519138101-570d1dca3d66?w=600&h=400&fit=crop&q=80', desc: 'FR, FRLS copper wires', overlay: 'rgba(236,72,153,0.85)' },
  { id: 'FANS', name: 'Fans', nameML: 'ഫാനുകൾ', img: '/categories/fans.jpg', icon: '/icons/fans.svg', fallback: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=600&h=400&fit=crop&q=80', desc: 'Ceiling, exhaust, table', overlay: 'rgba(16,185,129,0.85)' },
  { id: 'INVERTER', name: 'Inverters & UPS', nameML: 'ഇൻവെർട്ടറുകൾ', img: '/categories/inverters.jpg', icon: '/icons/inverters.svg', fallback: 'https://images.unsplash.com/photo-1497435334941-8c899a0736db?w=600&h=400&fit=crop&q=80', desc: 'Power backup solutions', overlay: 'rgba(99,102,241,0.85)' },
  { id: 'TOOLS', name: 'Tools', nameML: 'ഉപകരണങ്ങൾ', img: '/categories/tools.jpg', icon: '/icons/tools.svg', fallback: 'https://images.unsplash.com/photo-1581783898377-1c85bf937427?w=600&h=400&fit=crop&q=80', desc: 'Pliers, testers, kits', overlay: 'rgba(234,179,8,0.85)' },
  { id: 'APPLIANCES', name: 'Appliances', nameML: 'ഉപകരണങ്ങൾ', img: '/categories/appliances.jpg', icon: '/icons/appliances.svg', fallback: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=600&h=400&fit=crop&q=80', desc: 'Home electrical items', overlay: 'rgba(244,63,94,0.85)' },
  { id: 'ACCESSORIES', name: 'Accessories', nameML: 'ആക്സസറീസ്', img: '/categories/accessories.jpg', icon: '/icons/accessories.svg', fallback: 'https://images.unsplash.com/photo-1555664424-778a1e5e1b48?w=600&h=400&fit=crop&q=80', desc: 'Fittings & connectors', overlay: 'rgba(34,197,94,0.85)' },
  { id: 'CIRCUIT_BREAKERS', name: 'Circuit Breakers', nameML: 'സർക്യൂട്ട് ബ്രേക്കറുകൾ', img: '/categories/circuit-breakers.jpg', icon: '/icons/circuit-breakers.svg', fallback: 'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=600&h=400&fit=crop&q=80', desc: 'MCBs, RCCBs, panels', overlay: 'rgba(100,116,139,0.85)' },
  { id: 'WATER_HEATERS', name: 'Water Heaters', nameML: 'വാട്ടർ ഹീറ്ററുകൾ', img: '/categories/water-heaters.jpg', icon: '/icons/water-heaters.svg', fallback: 'https://images.unsplash.com/photo-1585128792020-803d29415281?w=600&h=400&fit=crop&q=80', desc: 'Geysers & instant heaters', overlay: 'rgba(249,115,22,0.85)' },
];

const brands = [
  { name: 'Havells', logo: '/brands/havells.svg', banner: '/brands/banners/havells.png', color: '#E52E2E', accent: '#E52E2E', categories: 'Switches · Wires · Lighting' },
  { name: 'V-Guard', logo: '/brands/vguard.svg', banner: '/brands/banners/vguard.png', color: '#fcbe0f', accent: '#fcbe0f', categories: 'Fans · Appliances · Wires' },
  { name: 'Polycab', logo: '/brands/polycab.svg', banner: '/brands/banners/polycab.png', color: '#E8231A', accent: '#E8231A', categories: 'Wires & Cables · Switchgear' },
  { name: 'Crompton', logo: '/brands/crompton.svg', banner: '/brands/banners/crompton.png', color: '#1B5FAD', accent: '#3b82f6', categories: 'Fans · Pumps · Appliances' },
  { name: 'Philips', logo: '/brands/philips.svg', banner: '/brands/banners/philips.png', color: '#0B5ED7', accent: '#0B5ED7', categories: 'LED Lighting · Home Solutions' },
  { name: 'Anchor', logo: '/brands/anchor.svg', banner: '/brands/banners/anchor.png', color: '#003B73', accent: '#003B73', categories: 'Switches · Sockets · MCBs' },
  { name: 'Legrand', logo: '/brands/legrand.svg', banner: '/brands/banners/legrand.png', color: '#E30613', accent: '#E30613', categories: 'Switches · Wiring Devices' },
  { name: 'Schneider', logo: '/brands/schneider.svg', banner: '/brands/banners/schneider.png', color: '#3DCD58', accent: '#3DCD58', categories: 'Switchgear · Protection' },
  { name: 'RR Kabel', logo: '/brands/rrkabel.svg', banner: '/brands/banners/rrkabel.png', color: '#003B8E', accent: '#003B8E', categories: 'Wires & Cables · Power' },
];

const testimonials = [
  { name: 'Sreejith Menon', role: 'Homeowner, Thrissur', text: 'Excellent quality products and very competitive pricing. The staff helped me choose the right wiring for my new house. Highly recommended!', rating: 5 },
  { name: 'Anjali Nair', role: 'Interior Designer', text: 'My go-to store for all electrical fittings. Their range of modular switches and decorative lighting is impressive. Fast delivery too.', rating: 5 },
  { name: 'Vishnu Pillai', role: 'Licensed Electrician', text: 'As a professional electrician, I need reliable products. Ceedees Electricals has never let me down. Great dealer pricing for bulk orders.', rating: 5 },
];

const HOME_SERVICES = [
  { id: 'installation', name: 'Installation', price: '₹299+', icon: '⚡', desc: 'Fans, lights, switches & more' },
  { id: 'repair',       name: 'Repair',        price: '₹399+', icon: '🔧', desc: 'Fix any electrical issue fast' },
  { id: 'wiring',       name: 'Wiring',         price: '₹999+', icon: '🔌', desc: 'New & rewiring jobs' },
  { id: 'maintenance',  name: 'Maintenance',    price: '₹499+', icon: '🛠️', desc: 'Regular safety checkups' },
  { id: 'inspection',   name: 'Inspection',     price: '₹199+', icon: '🔍', desc: 'Full electrical audit' },
  { id: 'emergency',    name: 'Emergency 24/7', price: '₹599+', icon: '🚨', desc: 'Urgent call-outs anytime' },
];

/* ── Hero Background Slideshow (outside component to avoid recreation on every render) ── */
const heroSlides = [
  '/hero/slide-1.png',
  '/hero/slide-2.png',
  '/hero/slide-3.png',
  '/hero/slide-4.png',
  '/hero/slide-5.png',
  '/hero/slide-6.png',
  '/hero/slide-7.png',
];

function Home() {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [hotDeals, setHotDeals] = useState([]);
  const lang = 'en';
  const dealScrollRef = useRef(null);
  const prodScrollRef = useRef(null);


  const [heroIdx, setHeroIdx] = useState(0);

  useEffect(() => {
    const heroTimer = setInterval(() => {
      setHeroIdx(prev => (prev + 1) % heroSlides.length);
    }, 7000);
    return () => clearInterval(heroTimer);
  }, []);

  /* ── Brand Slider ── */
  const [brandIdx, setBrandIdx] = useState(0);
  const [brandPaused, setBrandPaused] = useState(false);
  const brandTimerRef = useRef(null);

  useEffect(() => {
    if (brandPaused) return;
    brandTimerRef.current = setInterval(() => {
      setBrandIdx(prev => (prev + 1) % brands.length);
    }, 10000);
    return () => clearInterval(brandTimerRef.current);
  }, [brandPaused]);

  const goToBrand = (idx) => {
    setBrandIdx(idx);
    setBrandPaused(true);
    setTimeout(() => setBrandPaused(false), 15000);
  };
  const prevBrand = () => goToBrand((brandIdx - 1 + brands.length) % brands.length);
  const nextBrand = () => goToBrand((brandIdx + 1) % brands.length);

  const scroll = (ref, dir) => {
    if (ref.current) {
      const amount = dir === 'left' ? -320 : 320;
      ref.current.scrollBy({ left: amount, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await api.get('/products?limit=20');
        const all = res.data.data || [];
        setFeaturedProducts(all.filter(p => p.slug).slice(0, 8));
        // Hot deals = products with a discount, sorted by % off descending
        const deals = all
          .filter(p => p.slug && p.mrp > p.sellingPrice)
          .sort((a, b) => {
            const da = ((a.mrp - a.sellingPrice) / a.mrp);
            const db = ((b.mrp - b.sellingPrice) / b.mrp);
            return db - da;
          })
          .slice(0, 8);
        setHotDeals(deals);
      } catch (err) {
        if (process.env.NODE_ENV === 'development') console.log('Products will load when backend is connected');
      }
    };
    fetchProducts();
  }, []);

  return (
    <div className="home">
      <OldFanOfferPopup />
      {/* ===== HERO ===== */}
      <section className="hero">
        {/* Crossfade hero backgrounds */}
        {heroSlides.map((src, i) => (
          <div
            key={src}
            className={`hero-bg${i === heroIdx ? ' hero-bg-active' : ''}`}
            style={{ backgroundImage: `url(${process.env.PUBLIC_URL}${src})` }}
          />
        ))}
        <div className="hero-bg-layers">
          <div className="hero-gradient"></div>
          <div className="hero-pattern"></div>
        </div>
        <div className="container hero-content-v2">
          {/* Left column — text */}
          <div className="hero-left">
            <div className="hero-badge">
              <FiZap size={14} />
              <span>Serving Kerala Since 1981 — Thrissur</span>
            </div>
            <h1 className="hero-title">
              Your One-Stop <span className="text-gradient">Electrical Store</span> for Quality Products
            </h1>
            <p className="hero-desc">
              Shop LED lights, switches, wires, fans, inverters, tools and more from top Indian brands. GST-compliant billing, wholesale pricing for dealers, and doorstep delivery across Kerala.
            </p>
            <div className="hero-actions">
              <Link to="/shop" className="btn-hero-primary">
                Browse Products <FiArrowRight />
              </Link>
              <Link to="/contact" className="btn-hero-secondary">
                <FiPhone size={16} /> Get a Quote
              </Link>
            </div>
            <div className="hero-trust">
              <span className="trust-item"><span className="trust-icon">✓</span> ISI Certified Brands</span>
              <span className="trust-item"><span className="trust-icon">✓</span> GST Invoice</span>
              <span className="trust-item"><span className="trust-icon">✓</span> Wholesale Pricing</span>
            </div>
          </div>

          {/* Right column — stat cards 2×2 */}
          <div className="hero-stats-bar">
            <div className="hero-stat-card hsc-1">
              <div className="hsc-icon" style={{background: '#dbeafe'}}><img src="/icons/led-lights.svg" alt="" style={{width: 28, height: 28}} /></div>
              <div>
                <div className="hsc-number">2,000+</div>
                <div className="hsc-label">Products Available</div>
              </div>
            </div>
            <div className="hero-stat-card hsc-2">
              <div className="hsc-icon" style={{background: '#d1fae5'}}><img src="/emblem-header.png" alt="" style={{width: 28, height: 28, borderRadius: '50%'}} /></div>
              <div>
                <div className="hsc-number">40+</div>
                <div className="hsc-label">Years of Trust</div>
              </div>
            </div>
            <div className="hero-stat-card hsc-3">
              <div className="hsc-icon" style={{background: '#fef3c7'}}><FiStar size={24} color="#f59e0b" /></div>
              <div>
                <div className="hsc-number">10,000+</div>
                <div className="hsc-label">Happy Customers</div>
              </div>
            </div>
            <div className="hero-stat-card hsc-4">
              <div className="hsc-icon" style={{background: '#e0e7ff'}}><FiShield size={24} color="#6366f1" /></div>
              <div>
                <div className="hsc-number">10+</div>
                <div className="hsc-label">Premium Brands</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== TRUST BAR ===== */}
      <section className="trust-bar">
        <div className="container trust-bar-inner">
          <div className="trust-feature">
            <img src="/icons/quality-shield.svg" alt="" className="tf-img" />
            <div>
              <strong>Quality Assured</strong>
              <span>All products from ISI certified brands</span>
            </div>
          </div>
          <div className="trust-feature">
            <img src="/icons/fast-delivery.svg" alt="" className="tf-img" />
            <div>
              <strong>Fast Delivery</strong>
              <span>Across Thrissur & Kerala</span>
            </div>
          </div>
          <div className="trust-feature">
            <img src="/icons/expert-support.svg" alt="" className="tf-img" />
            <div>
              <strong>Expert Support</strong>
              <span>Professional guidance from electricians</span>
            </div>
          </div>
          <div className="trust-feature">
            <img src="/icons/best-prices.svg" alt="" className="tf-img" />
            <div>
              <strong>Best Prices</strong>
              <span>Competitive pricing, dealer discounts</span>
            </div>
          </div>
        </div>
      </section>

      {/* ===== HOT DEALS ===== */}
      {hotDeals.length > 0 && (
        <section className="section-deals">
          <div className="container">
            <div className="deals-header">
              <div className="deals-title-group">
                <span className="deals-fire">🔥</span>
                <div>
                  <h2 className="deals-title">{lang === 'en' ? "Today's Hot Deals" : 'ഇന്നത്തെ ഓഫറുകൾ'}</h2>
                  <p className="deals-subtitle">Best prices on top brands — limited stock!</p>
                </div>
              </div>
              <Link to="/shop" className="section-link">See All Deals <FiArrowRight /></Link>
            </div>
            <div className="scroll-wrapper">
              <button className="scroll-btn scroll-btn-left" onClick={() => scroll(dealScrollRef, 'left')} aria-label="Scroll left"><FiChevronLeft size={22} /></button>
              <button className="scroll-btn scroll-btn-right" onClick={() => scroll(dealScrollRef, 'right')} aria-label="Scroll right"><FiChevronRight size={22} /></button>
            <div className="deal-scroll" ref={dealScrollRef}>
              {hotDeals.map(prod => {
                const discount = prod.mrp > prod.sellingPrice
                  ? Math.round(((prod.mrp - prod.sellingPrice) / prod.mrp) * 100)
                  : 0;
                return (
                  <Link key={prod._id} to={`/product/${prod.slug}`} className="deal-card">
                    {discount > 0 && <div className="deal-badge">{discount}% OFF</div>}
                    <div className="deal-img">
                      {prod.images?.[0]
                        ? <img src={prod.images[0].url} alt={prod.name} loading="lazy" />
                        : <div className="deal-img-placeholder">⚡</div>
                      }
                    </div>
                    <div className="deal-info">
                      <span className="deal-brand">{prod.brand}</span>
                      <h3 className="deal-name">{prod.name}</h3>
                      <div className="deal-pricing">
                        <span className="deal-price">₹{prod.sellingPrice?.toLocaleString('en-IN')}</span>
                        {prod.mrp > prod.sellingPrice && (
                          <span className="deal-mrp">₹{prod.mrp?.toLocaleString('en-IN')}</span>
                        )}
                      </div>
                      <div className="deal-cta">Shop Now <FiArrowRight size={13} /></div>
                    </div>
                  </Link>
                );
              })}
            </div>
            </div>
          </div>
        </section>
      )}

      {/* ===== SERVICES SPOTLIGHT ===== */}
      <section className="section-services-home">
        <div className="container">
          <div className="svh-new-badge">
            <FiZap size={13} /> NEW IN KERALA — Book a Certified Electrician Online
          </div>
          <div className="svh-layout">
            <div className="svh-left">
              <h2 className="svh-title">
                {lang === 'en'
                  ? <>Licensed Electricians<br /><span className="svh-highlight">at Your Doorstep</span></>
                  : <>ലൈസൻസ്ഡ് ഇലക്ട്രീഷ്യൻ<br /><span className="svh-highlight">വീട്ടിലെത്തും</span></>}
              </h2>
              <p className="svh-desc">
                Kerala's first platform to book a certified electrician online — available in Thrissur. Same-day slots, transparent pricing, insured professionals.
              </p>
              <div className="svh-trust-pills">
                <span>✅ Same-day service</span>
                <span>✅ 10-day easy returns</span>
                <span>✅ Licensed & insured</span>
                <span>✅ No hidden charges</span>
              </div>
              <div className="svh-actions">
                <Link to="/services" className="svh-btn-primary">
                  Book a Service <FiArrowRight />
                </Link>
                <a href="tel:+919447672888" className="svh-btn-secondary">
                  <FiPhone size={15} /> Call Now
                </a>
              </div>
            </div>
            <div className="svh-right">
              <div className="svh-grid">
                {HOME_SERVICES.map(svc => (
                  <Link key={svc.id} to="/services" className="svh-card">
                    <div className="svh-card-icon">{svc.icon}</div>
                    <div className="svh-card-name">{svc.name}</div>
                    <div className="svh-card-price">{svc.price}</div>
                    <div className="svh-card-desc">{svc.desc}</div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== FEATURED PRODUCTS ===== */}
      <section className="section-featured">
        <div className="container">
          <div className="section-header">
            <div>
              <h2 className="section-title">{lang === 'en' ? 'Featured Products' : 'പ്രത്യേക ഉൽപ്പന്നങ്ങൾ'}</h2>
              <p className="section-subtitle">Top-selling electrical products at the best prices</p>
            </div>
            <Link to="/shop" className="section-link">See All Products <FiArrowRight /></Link>
          </div>
          {featuredProducts.length > 0 ? (
            <div className="scroll-wrapper">
              <button className="scroll-btn scroll-btn-left" onClick={() => scroll(prodScrollRef, 'left')} aria-label="Scroll left"><FiChevronLeft size={22} /></button>
              <button className="scroll-btn scroll-btn-right" onClick={() => scroll(prodScrollRef, 'right')} aria-label="Scroll right"><FiChevronRight size={22} /></button>
              <div className="prod-scroll" ref={prodScrollRef}>
                {featuredProducts.filter(p => p.slug).map((prod) => (
                  <Link key={prod._id} to={`/product/${prod.slug}`} className="prod-card">
                    <div className="prod-media">
                      {prod.images?.[0] ? (
                        <img src={prod.images[0].url} alt={prod.name} loading="lazy" />
                      ) : (
                        <div className="prod-placeholder">
                          <img src={categories.find(c => c.id === prod.category)?.icon || '/icons/accessories.svg'} alt="" loading="lazy" style={{width: 48, height: 48, opacity: 0.5}} />
                        </div>
                      )}
                      {prod.mrp > prod.sellingPrice && (
                        <span className="prod-discount">
                          {Math.round(((prod.mrp - prod.sellingPrice) / prod.mrp) * 100)}% OFF
                        </span>
                      )}
                    </div>
                    <div className="prod-info">
                      <span className="prod-brand">{prod.brand}</span>
                      <h3 className="prod-name">{prod.name}</h3>
                      <div className="prod-pricing">
                        <span className="prod-price">₹{prod.sellingPrice?.toLocaleString('en-IN')}</span>
                        {prod.mrp > prod.sellingPrice && (
                          <span className="prod-mrp">₹{prod.mrp?.toLocaleString('en-IN')}</span>
                        )}
                      </div>
                      <span className="prod-gst">+ 18% GST | HSN: {prod.hsnCode}</span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ) : (
            <div className="empty-products">
              <div className="empty-icon"><img src="/icons/led-lights.svg" alt="" style={{width: 48, height: 48}} /></div>
              <h3>Products Loading...</h3>
              <p>Our catalog is being set up. Browse categories above to explore.</p>
              <Link to="/shop" className="btn-primary">Go to Shop</Link>
            </div>
          )}
        </div>
      </section>

      {/* ===== BRANDS — Premium Dark Section ===== */}
      <section className="section-brands-v2">
        <div className="brands-v2-bg" />
        <div className="container brands-v2-content">
          {/* Badge */}
          <div className="brands-v2-badge">
            <FiCheckCircle size={14} /> AUTHORIZED DEALER
          </div>
          {/* Title */}
          <h2 className="brands-v2-title">
            {lang === 'en'
              ? <>Authorized Dealer of <span className="brands-v2-gold">Top Brands</span></>
              : 'പ്രമുഖ ബ്രാൻഡുകളുടെ അംഗീകൃത ഡീലർ'}
          </h2>
          <p className="brands-v2-sub">
            We stock only genuine, ISI-certified products from India's most trusted electrical brands.
          </p>
          {/* Trust points */}
          <div className="brands-v2-trust">
            <div className="brands-v2-trust-item"><FiShield size={16} className="brands-v2-trust-icon" /><div><strong>100% Genuine Products</strong><span>Authentic & Original</span></div></div>
            <div className="brands-v2-trust-item"><FiCheckCircle size={16} className="brands-v2-trust-icon" /><div><strong>Official Warranty</strong><span>Brand-backed assurance</span></div></div>
            <div className="brands-v2-trust-item"><FiAward size={16} className="brands-v2-trust-icon" /><div><strong>Quality You Can Trust</strong><span>Tested & ISI Certified</span></div></div>
            <div className="brands-v2-trust-item"><FiPackage size={16} className="brands-v2-trust-icon" /><div><strong>Bulk Orders Welcome</strong><span>Best prices for dealers</span></div></div>
          </div>
          {/* Brand Banner Slider */}
          <div className="brand-slider-wrap" onMouseEnter={() => setBrandPaused(true)} onMouseLeave={() => setBrandPaused(false)}>
            <div className="brand-slider">
              {/* Arrows */}
              <button className="brand-slider-arrow brand-slider-prev" onClick={prevBrand} aria-label="Previous brand">
                <FiChevronLeft size={22} />
              </button>
              <button className="brand-slider-arrow brand-slider-next" onClick={nextBrand} aria-label="Next brand">
                <FiChevronRight size={22} />
              </button>
              {/* Slide track */}
              <div className="brand-slider-track" style={{ transform: `translateX(-${brandIdx * 100}%)` }}>
                {brands.map((brand) => (
                  <Link key={brand.name} to={`/shop?brand=${encodeURIComponent(brand.name)}`} className="brand-slider-slide">
                    <img src={brand.banner} alt={`${brand.name} — Official Dealer`} className="brand-slider-img" />
                  </Link>
                ))}
              </div>
            </div>

            {/* Progress bar */}
            <div className="brand-slider-progress">
              <div className="brand-slider-progress-bar" key={brandIdx} style={{ animationDuration: brandPaused ? '0s' : '10s' }} />
            </div>

            {/* Brand logo dots */}
            <div className="brand-slider-dots">
              {brands.map((brand, i) => (
                <button key={brand.name} className={`brand-slider-dot${i === brandIdx ? ' active' : ''}`} onClick={() => goToBrand(i)} aria-label={brand.name}>
                  <img src={brand.logo} alt="" className="brand-slider-dot-logo" />
                </button>
              ))}
            </div>
          </div>

          {/* Footer tagline */}
          <div className="brands-v2-footer">
            <FiAward size={22} className="brands-v2-footer-icon" />
            <div>
              <strong>Trusted by <span className="brands-v2-gold">Electricians</span>. Preferred by <span className="brands-v2-gold">Professionals</span>.</strong>
              <span>Partner with Ceedees Electricals for quality products, best pricing & reliable support.</span>
            </div>
          </div>
        </div>
      </section>

      {/* ===== WHY CHOOSE US ===== */}
      <section className="section-why">
        <div className="container">
          <div className="section-header center">
            <div>
              <h2 className="section-title">Why Choose Ceedees Electricals?</h2>
              <p className="section-subtitle">Trusted since 1981 — we're not just a store, we're your electrical partner</p>
            </div>
          </div>
          <div className="why-grid">
            <div className="why-card">
              <div className="why-number">01</div>
              <h3>GST-Compliant Billing</h3>
              <p>Every purchase comes with a proper GST invoice with HSN codes — perfect for businesses, contractors, and tax filing.</p>
            </div>
            <div className="why-card">
              <div className="why-number">02</div>
              <h3>Wholesale & Dealer Pricing</h3>
              <p>Registered dealers and bulk buyers get special tiered pricing — Silver, Gold, and Platinum discount levels.</p>
            </div>
            <div className="why-card">
              <div className="why-number">03</div>
              <h3>40+ Years of Experience</h3>
              <p>Started in 1981, Ceedees Electricals has been the trusted name in Thrissur for quality electrical products and expert advice.</p>
            </div>
            <div className="why-card">
              <div className="why-number">04</div>
              <h3>Expert Guidance</h3>
              <p>Not sure what you need? Our experienced team helps you pick the right products for your project — call or WhatsApp us.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== TESTIMONIALS ===== */}
      <section className="section-testimonials">
        <div className="container">
          <div className="section-header center">
            <div>
              <h2 className="section-title">{lang === 'en' ? 'What Our Customers Say' : 'ഉപഭോക്തൃ അഭിപ്രായങ്ങൾ'}</h2>
              <p className="section-subtitle">Trusted by homeowners, electricians, and businesses across Kerala</p>
            </div>
          </div>
          <div className="test-grid">
            {testimonials.map((t, i) => (
              <div key={i} className="test-card">
                <div className="test-stars">
                  {Array.from({ length: t.rating }).map((_, j) => (
                    <FiStar key={j} fill="#fbbf24" color="#fbbf24" size={16} />
                  ))}
                </div>
                <p className="test-text">"{t.text}"</p>
                <div className="test-author">
                  <div className="test-avatar">{t.name.charAt(0)}</div>
                  <div>
                    <strong>{t.name}</strong>
                    <span>{t.role}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== CTA ===== */}
      <section className="section-cta">
        <div className="container">
          <div className="cta-box">
            <div className="cta-content">
              <h2>{lang === 'en' ? 'Ready to Power Your Project?' : 'നിങ്ങളുടെ പ്രോജക്ട് ആരംഭിക്കാൻ തയ്യാറാണോ?'}</h2>
              <p>Get in touch for bulk orders, project quotes, or any electrical product enquiry. We respond within 30 minutes during business hours.</p>
              <div className="cta-actions">
                <Link to="/shop" className="btn-cta-primary">Start Shopping <FiArrowRight /></Link>
                <a href="https://wa.me/919447672888" target="_blank" rel="noopener noreferrer" className="btn-cta-whatsapp">
                  WhatsApp Us
                </a>
              </div>
            </div>
            <div className="cta-visual">
              <img src="/emblem-header.png" alt="Ceedees Electricals" style={{width: 120, height: 120, borderRadius: '50%', opacity: 0.9}} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
